<template>
  <DialogFull :data="dialogSettings" @close="close">
    <template v-slot:dialog.body> </template>
    <div class="container col-lg-8 col-sm-12">
      <SelfScheduleSlots
        ref="selfScheduleSlots"
        :interviewFormat="interviewFormat"
        @onSlotsDataChange="handleSlotsDataChange"
        @onRemoveSlot="handleRemoveSlot"
      />
    </div>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
        Save Changes
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { INTERVIEWS_NAMESPACE } from "@/store/modules/bookings/interviews";
import {
  EDIT_SELF_SCHEDULE_SLOTS,
  FETCH_BOOKING_INTERVIEW_FORMATS
} from "@/store/modules/bookings/interviews/actions";
import { createNamespacedHelpers } from "vuex";
import { copyState } from "@/utils/helpers";
import { map, size, isEmpty, filter, find, uniqBy } from "lodash";
import SelfScheduleSlots from "@/views/bookings/BookingInterviews/components/dialogs/SelfScheduleInvites/SelfScheduleInvite/steps/SelfScheduleSlots/SelfScheduleSlots";

const {
  mapActions: mapInterviewActions,
  mapState: mapInterviewState
} = createNamespacedHelpers(INTERVIEWS_NAMESPACE);

export default {
  name: "EditSelfScheduleInterviewFormatDialog",
  props: {
    interviewFormat: {
      type: Object,
      required: true
    },
    isOpen: Boolean
  },
  components: {
    PrimaryButton,
    DialogFull,
    SelfScheduleSlots
  },
  created() {},
  data() {
    return {
      isLoading: false,
      slotsData: {},
      slotsToDelete: []
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Candidate Self-Schedule Interview"
      };
    },
    ...mapInterviewState(
      copyState([
        "interviewFormats",
        "isFetchingInterviewFormats",
        "interviewers",
        "isFetchingInterviewers"
      ])
    ),
    currentBookingId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapInterviewActions({
      fetchInterviewFormats: FETCH_BOOKING_INTERVIEW_FORMATS,
      editSelfScheduleSlots: EDIT_SELF_SCHEDULE_SLOTS
    }),
    handleSlotsDataChange(val) {
      this.slotsData = val;
    },
    handleRemoveSlot({ id }) {
      if (!find(this.slotsToDelete, { id })) {
        this.slotsToDelete.push({ id });
      }
    },
    getSlotsToRemove() {
      return uniqBy(
        filter(
          this.slotsToDelete,
          ({ id }) => !find(this.slotsData.interviewSlots, { id })
        ),
        "id"
      );
    },
    getSlotsToAdd() {
      return map(
        filter(this.slotsData.interviewSlots, ({ existing }) => !existing),
        ({ startTime, endTime }) => ({ startTime, endTime })
      );
    },
    async onEditSelfScheduleSlots() {
      const formattedInterviewers = map(
        this.slotsData.interviewers,
        ({ id }) => ({
          id
        })
      );
      const { location } = this.slotsData;
      await this.editSelfScheduleSlots({
        data: {
          slotsToAdd: this.getSlotsToAdd(),
          slotsToDelete: this.getSlotsToRemove(),
          interviewers: formattedInterviewers,
          location: location
        },
        interviewFormatId: this.interviewFormat.id
      });
    },
    async handleSubmit() {
      this.isLoading = true;
      const shouldEditSlots =
        !isEmpty(this.slotsData) || size(this.slotsToDelete);
      if (shouldEditSlots) {
        await this.onEditSelfScheduleSlots();
        this.fetchInterviewFormats({
          bookingId: this.currentBookingId,
          withInclude: true
        });
      }
      this.close();
      this.isLoading = false;
    },
    close() {
      this.$emit("close");
    },
    size
  }
};
</script>

<style lang="scss"></style>
